import { createSearchAndFilterDisplayOptions } from 'stores/adapters/bex-api/search/search-sort-filter-adapter';
import { mapMessageModel } from 'src/common/stores/adapters/bex-api/search/search-results-adapter';

import { HotelMapModel } from 'models';

import { LodgingPwaPropertySearch } from '__generated__/api';

export const mapMap = (query: LodgingPwaPropertySearch.Query): HotelMapModel | null => {
  const { map, sortAndFilter } = query.propertySearch;

  if (!map) {
    return null;
  }

  return {
    ...map,
    filterDisplayOptions: createMapFilterDisplayOptions(sortAndFilter),
    messagingModel: map.messagingModel && mapMessageModel(map.messagingModel, 'MessageResult'),
    showSearchButton: false,
    searchMessage: null,
    ...adaptMapBounds(query),
  };
};

const adaptMapBounds = (query: LodgingPwaPropertySearch.Query): any => {
  const { map } = query.propertySearch;
  const ne = map.bounds && map.bounds.northeast;
  const sw = map.bounds && map.bounds.southwest;

  return {
    center: {
      lat: map.center && map.center.latitude,
      lng: map.center && map.center.longitude,
    },
    bounds: {
      ne: {
        lat: ne && ne.latitude,
        lng: ne && ne.longitude,
      },
      sw: {
        lat: sw && sw.latitude,
        lng: sw && sw.longitude,
      },
    },
  };
};

export const createMapFilterDisplayOptions = (sortAndFilter?: LodgingPwaPropertySearch.SortAndFilter): any => {
  const mapFiltersBlackList = ['sort'];
  const mapFilters = Object.assign({}, createSearchAndFilterDisplayOptions(sortAndFilter));

  mapFilters.filters.displayFields = mapFilters.filters.displayFields.filter(item => !mapFiltersBlackList.includes(item));

  return mapFilters;
};
